/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prettier/prettier */
/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-no-bind */
import { toArray } from "lodash";
import moment from "moment";
import { useEffect } from "react";
import { Form } from "react-bootstrap";
import useDataTable from "../../../hooks/useDataTable";
import { useD1Approval } from "./ContextAPI";

export default function ShowTable({ data }) {
  const { setReceiveList, receiveData, setReceiveData } = useD1Approval();

  // requisitionRowHandler handles the change in approved quantity and remarks for each drug item in the table. It updates the receiveData state with the new values, ensuring that the existing data is preserved and only the relevant field is updated. If the approved quantity is cleared, it removes the item from the receiveData state.
  const requisitionRowHandler = (value, item, field = "approved_request_qty") => {
    const existingData = receiveData?.[item.drug_id] || {};

    const initialApprovedQty = existingData.approved_request_qty !== undefined
      ? existingData.approved_request_qty
      : (item.approved_request_qty !== "0" ? item.approved_request_qty : item.requested_qty);

    const updatedItem = {
      ...item,
      ...existingData,

      approved_request_qty: initialApprovedQty,

      [field]: value,
    };

    const newList = {
      ...receiveData,

      [item.drug_id]: updatedItem,
    };

    if (value === "" && field === "approved_request_qty") {
      delete newList[item.drug_id];
    }

    setReceiveData(newList);
  };

  useEffect(() => {
    const arr = toArray(receiveData);
    setReceiveList(arr);
  }, [receiveData]);

  const columns = [
    {
      name: "Item Names",
      selector: (row) => row.drug_name,
      sortable: true,
      wrap: true,
      width: "250px",
      fixed: true,
    },
    {
      name: "Opening Balance",
      selector: (row) => row.opening_balance,
      sortable: true,
    },
    {
      name: "Total Quantity Received During The Month",
      selector: (row) => row.received_qty,
      sortable: true,
    },
    {
      name: "Total Quantity Consumed",
      selector: (row) => row.consumed_qty,
      sortable: true,
      width: "150px",
    },
    {
      name: "Days Out Of Stock",
      selector: (row) => row.stock_out_days,
      sortable: true,
    },
    {
      name: "Average Monthly Consumption",
      selector: (row) => row.avg_monthly_consumption,
      sortable: true,
    },
    {
      name: "Total Returned",
      selector: (row) => row.total_return,
      sortable: true,
      width: "150px",
    },
    {
      name: "Expired / Damaged",
      selector: (row) => row.expired_qty,
      sortable: true,
    },
    {
      name: "Earliest Expiry",
      selector: (row) => row.expire_date,
      format: (row) => moment(row.expire_date).format("DD MMM YYYY"),
      sortable: true,
      width: "150px",
    },
    {
      name: "Closing Balance",
      selector: (row) => row.closing_balance,
      sortable: true,
    },
    {
      name: "Theoretical Stock",
      selector: (row) => row.theoritical_stock,
      sortable: true,
    },
    {
      name: "Days Available",
      selector: (row) => row.number_of_days_available_stock,
      sortable: true,
    },
    {
      name: "Request Qty",
      selector: (row) => row.requested_qty,
      sortable: true,
    },

    {
      name: "Approve Quantity",
      selector: (row) => row.approved_request_qty,
      cell: (row) => (
        <Form.Control
          size="sm"
          type="number"
          value={receiveData?.[row.drug_id]?.approved_request_qty ?? row.requested_qty ?? ""}
          onChange={(e) => requisitionRowHandler(e.target.value, row)}
        />
      ),
      reorder: true,
      width: "150px",
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      cell: (row) => (
        <Form.Control
          size="sm"
          type="text"
          placeholder="Enter remarks"
          value={receiveData?.[row.drug_id]?.remarks ?? row.remarks}
          onChange={(e) => {
            requisitionRowHandler(e.target.value, row, "remarks");
          }}
        />
      ),
      width: "200px",
      reorder: true,
    },
  ];


  const search_column = {
    drug_name: "Name",
  };



  return useDataTable({
    columns,
    data,
    search_column,
    pagination: false,
  });
}
